/* eslint-disable
    func-names,
    max-len,
    no-cond-assign,
    no-param-reassign,
    no-shadow,
    no-unused-vars,
    one-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// coffeelint: disable=max_line_length
const parseUrl = require('url').parse;
const _ = require('lodash');

const deps = [require('angular-ui-router')];

module.exports = angular
  .module('.data.service.url', deps)

  .config($urlMatcherFactoryProvider => $urlMatcherFactoryProvider.strictMode(false))
  .factory('BenchUrl', ($state, $urlMatcherFactory) => {
    const urlRegex =
      /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/gi;

    const parseOldDate = function (date) {
      if (typeof date !== 'string') {
        return null;
      }
      return date.replace(/([0-9]{2})-([0-9]{2})-([0-9]{4})/g, '$3-$1-$2');
    };

    const matchUrl = function (url, matcher, params = {}) {
      const urlMatcher = $urlMatcherFactory.compile(matcher, { params });
      const { pathname, query } = parseUrl(url, true);

      return urlMatcher.exec(pathname, query);
    };

    const isDefined = v => v != null;

    return {
      urlMatchers: {
        'cwa.newsFeed.events': {
          tests: [
            '/app/{clientId}/dashboard',
            '/app/{clientId}/new-dashboard',
            '/app/{clientId:[0-9]*}',
            '/app',
          ],
          serialize({ clientId }) {
            return _.pickBy({ clientId }, isDefined);
          },
        },
        'cwa.newsFeed.feed': {
          tests: ['/app/{clientId}/dashboard/{conversationId}'],
          serialize({ clientId, conversationId }) {
            const anchorScroll = conversationId;

            return _.pickBy({ clientId, anchorScroll }, isDefined);
          },
        },
        'cwa.reports.ledger': {
          tests: [
            '/app/{clientId}/search/{searchPattern}/{ledgerAccountId}/start/{start}/end/{end}?returl',
            '/app/{clientId}/{returl:income-statement|balance-sheet}/{type:expenses|revenues|assets|liabilities|equity|operatingexpenses|cogsexpenses}/{ledgerAccountId}/start/{start}/end/{end}/{pageTag:page}/{page}',
            '/app/{clientId}/{returl:income-statement|balance-sheet}/{type:expenses|revenues|assets|liabilities|equity|operatingexpenses|cogsexpenses}/{ledgerAccountId}',
          ],
          params: {
            pageTag: { value: null, squash: true },
            page: { value: null, squash: true },
          },
          serialize({ clientId, searchPattern, ledgerAccountId, start, end, returl }) {
            let pattern;
            const reportType = returl || 'income-statement';
            const startDate = parseOldDate(start);
            const endDate = parseOldDate(end);
            if (searchPattern != null) {
              pattern = decodeURIComponent(searchPattern);
            }

            return _.pickBy(
              {
                clientId,
                pattern,
                startDate,
                endDate,
                reportType,
                ledgerAccountId,
              },
              isDefined,
            );
          },
        },
        'cwa.reports.ledger.transaction': {
          tests: [
            '/app/{clientId}/search/{searchPattern}/{ledgerAccountId}/start/{start}/end/{end}/transaction/{transactionId:[0-9a-zA-Z]*}?returl',
            '/app/{clientId}/{returl:income-statement|balance-sheet}/{type:expenses|revenues|assets|liabilities|equity|operatingexpenses|cogsexpenses}/{ledgerAccountId}/start/{start}/end/{end}/transaction/{transactionId:[0-9a-zA-Z]*}',
          ],
          serialize({
            clientId,
            searchPattern,
            ledgerAccountId,
            start,
            end,
            transactionId,
            returl,
          }) {
            let pattern;
            const reportType = returl || 'income-statement';
            const startDate = parseOldDate(start);
            const endDate = parseOldDate(end);
            if (searchPattern != null) {
              pattern = decodeURIComponent(searchPattern);
            }

            return _.pickBy(
              {
                clientId,
                pattern,
                startDate,
                endDate,
                reportType,
                ledgerAccountId,
                transactionId,
              },
              isDefined,
            );
          },
        },
        'cwa.reports.search': {
          tests: [
            '/app/{clientId}/search/{searchPattern}/{startTag:start}/{start}/{endTag:end}/{end}?returl',
          ],
          params: {
            startTag: { value: null, squash: true },
            start: { value: null, squash: true },
            endTag: { value: null, squash: true },
            end: { value: null, squash: true },
          },
          serialize({ clientId, searchPattern, start, end }) {
            let pattern;
            const startDate = parseOldDate(start);
            const endDate = parseOldDate(end);
            if (searchPattern != null) {
              pattern = decodeURIComponent(searchPattern);
            }

            if ((pattern != null ? pattern.slice(0, 3) : undefined) === 'id:') {
              return false;
            }

            return _.pickBy(
              {
                clientId,
                pattern,
                startDate,
                endDate,
              },
              isDefined,
            );
          },
        },
        'cwa.reports.search.transaction': {
          tests: [
            '/app/{clientId}/transaction/{transactionId}',
            '/app/{clientId}/search/id:{transactionId}',
            '/app/{clientId}/search/id:{transactionId}/{startTag:start}/{start}/{endTag:end}/{end}?returl',
            '/app/{clientId}/search/{searchPattern}/{startTag:start}/{start}/{endTag:end}/{end}/transaction/{transactionId}?returl',
          ],
          params: {
            startTag: { value: null, squash: true },
            start: { value: null, squash: true },
            endTag: { value: null, squash: true },
            end: { value: null, squash: true },
          },
          serialize({ clientId, searchPattern, start, end, transactionId }) {
            let endDate, id, pattern, startDate;
            if (start != null && end != null) {
              startDate = parseOldDate(start);
              endDate = parseOldDate(end);
            }

            if (searchPattern != null) {
              pattern = decodeURIComponent(searchPattern);
            } else if (transactionId) {
              id = transactionId;
            }

            return _.pickBy(
              {
                clientId,
                pattern,
                startDate,
                endDate,
                transactionId,
                id,
              },
              isDefined,
            );
          },
        },
        'cwa.documents.other': {
          tests: [
            '/app/{clientId}/new-folders/{documentFilter:statements|receipts|tax|other}/{dateFilter}/{ledgerTag:ledger}/{ledger}',
            '/app/{clientId}/folders/{documentFilter:statements|receipts|tax|other}/{dateFilter}/{ledgerTag:ledger}/{ledger}',
          ],
          params: {
            ledgerTag: { value: null, squash: true },
            ledger: { value: null, squash: true },
          },
          serialize({ clientId, documentFilter, dateFilter }) {
            // CWA uses statement / receipt instead of statements / receipts
            let from, to, year;
            if (documentFilter.slice(-1) === 's') {
              documentFilter = documentFilter.slice(0, -1);
            }

            if (dateFilter === 'all') {
              year = new Date().getFullYear();
              from = `${year}-01-01`;
              to = `${year}-12-31`;
            } else if (dateFilter.length === 4) {
              year = dateFilter;

              from = `${year}-01-01`;
              to = `${year}-12-31`;
            } else {
              const arr = dateFilter.match(/([0-9]{1,2})-(?:[0-9]{1,2})-([0-9]{4})/i);
              if (arr.length === 3) {
                year = arr[2];
                const month = `0${arr[1]}`.slice(-2);

                const date = new Date(year, month, 0);
                const lastDayOfMonth = date.getDate();

                from = `${year}-${month}-01`;
                to = `${year}-${month}-${lastDayOfMonth}`;
              } else {
                return false;
              }
            }

            return _.pickBy(
              {
                clientId,
                documentFilter,
                from,
                to,
              },
              isDefined,
            );
          },
        },
        'cwa.accounts.connections': {
          tests: ['/app/{clientId}/accounts'],
          serialize({ clientId }) {
            return _.pickBy({ clientId }, isDefined);
          },
        },
        'cwa.documents.uploads': {
          tests: ['/app/{clientId}/upload'],
          serialize({ clientId }) {
            return _.pickBy({ clientId }, isDefined);
          },
        },
        'cwa.reports.incomeStatement': {
          tests: [
            '/app/{clientId}/income-statement',
            '/app/{clientId}/income-statement/start/{start}/end/{end}',
          ],
          serialize({ clientId, start, end }) {
            const startDate = parseOldDate(start);
            const endDate = parseOldDate(end);

            return _.pickBy({ clientId, startDate, endDate }, isDefined);
          },
        },
        'cwa.reports.balanceSheet': {
          tests: [
            '/app/{clientId}/balance-sheet',
            '/app/{clientId}/balance-sheet/start/{start}/end/{end}',
          ],
          serialize({ clientId, start, end }) {
            const startDate = parseOldDate(start);
            const endDate = parseOldDate(end);

            return _.pickBy({ clientId, startDate, endDate }, isDefined);
          },
        },
        'cwa.documents.unmatchedReceipts': {
          tests: ['/app/{clientId}/unmatched-receipts/start/{start}/end/{end}'],
          serialize({ clientId, start, end }) {
            const from = parseOldDate(start);
            const to = parseOldDate(end);

            return _.pickBy({ clientId, from, to }, isDefined);
          },
        },
        'cwa.documents.unmatchedReceipts.receipt': {
          tests: [
            '/app/{clientId}/unmatched-receipt/{receiptId:[0-9a-zA-Z]*}',
            '/app/{clientId}/unmatched-receipt/start/{start}/end/{end}/transaction/{receiptId:[0-9a-zA-Z]*}',
          ],
          serialize({ clientId, receiptId, start, end }) {
            const from = parseOldDate(start);
            const to = parseOldDate(end);

            return _.pickBy(
              {
                clientId,
                from,
                to,
                receiptId,
              },
              isDefined,
            );
          },
        },
        'cwa.settings.billing': {
          tests: ['/app/{clientId}/settings/billing'],
          serialize({ clientId }) {
            return _.pickBy({ clientId }, isDefined);
          },
        },
        'cwa.settings.profile': {
          tests: ['/app/{clientId}/settings/clientsettings'],
          serialize({ clientId }) {
            return _.pickBy({ clientId }, isDefined);
          },
        },
      },

      cwaRoot(text) {
        // this regex is used to reconstruct the incomin url into a client friendly url, on the targeted environment.
        const regexp =
          /(?<protocol>https?:\/\/)(?<www>www\.)?(?<host>([a-z0-9]+\.?){3,})(?<rest>.*)/;
        const matchResult = text.match(regexp);
        const { protocol, host } = matchResult.groups;
        return `${protocol}${host.replace(/^bktools\.in/, 'app')}/`;
      },

      isCWA(url) {
        return url.match(new RegExp(`${this.cwaRoot(url)}`, 'i')) != null;
      },

      getOldUrls(text) {
        const isBench = url =>
          url.match(/(bench\.co|in\.nginx\.service\.bench|10sheet\.ca)\/app/i) != null;
        const getLinks = source => source.match(urlRegex) || [];

        return getLinks(text).filter(isBench);
      },

      parseText(text) {
        return this.parseLinks(text)
          .filter(({ oldUrl, newUrl }) => newUrl != null)
          .reduce(
            (acc, { oldUrl, newUrl }) => acc.replace(oldUrl, this.cwaRoot(text) + newUrl),
            text,
          );
      },

      parseLinks(text) {
        return this.getOldUrls(text).map(oldUrl => ({ oldUrl, newUrl: this.mapUrl(oldUrl) }));
      },

      validBenchLinks(text) {
        let needle;
        return (
          text == null ||
          ((needle = null),
          !this.parseLinks(text)
            .map(({ oldUrl, newUrl }) => newUrl)
            .includes(needle))
        );
      },

      parse(url) {
        const testUrl = (url, matcher) =>
          function (acc, test) {
            let data;
            if (acc == null && (data = matchUrl(url, test, matcher.params))) {
              return matcher.serialize(data);
            }
            return acc;
          };
        return _.reduce(
          this.urlMatchers,
          (acc, matcher, state) => {
            let params;
            if (acc == null && (params = _.reduce(matcher.tests, testUrl(url, matcher), null))) {
              return { state, params };
            }
            return acc;
          },
          null,
        );
      },

      mapUrl(url) {
        let data;
        if (!(data = this.parse(url))) {
          return null;
        }
        return $state.href(`mock.${data.state}`, data.params).replace(/#?\/mock\//, '');
      },
    };
  })
  .config($stateProvider => {
    const searchParams = [
      'id',
      'pattern',
      'vendor',
      'ledger-id',
      'notes',
      'ledger-category',
      'ledger-name',
      'amount-leq',
      'amount-geq',
      'amount-eq',
      'page',
      'results-per-page',
    ];

    const currentYear = new Date().getFullYear();

    return $stateProvider
      .state('mock', {
        abstract: true,
        url: '/mock',
      })
      .state('mock.businesses', {
        abstract: true,
        url: '/businesses',
      })
      .state('mock.cwa', {
        abstract: true,
        url: '/{clientId:[0-9]*}?originalURL&{state:[0-9]*}',
        params: {
          clientId: {
            value: '',
            squash: true,
          },
          state: {
            value: '',
            squash: true,
          },
        },
      })
      .state('mock.cwa.accounts', {
        abstract: true,
        url: '/accounts',
      })
      .state('mock.cwa.accounts.connections', {
        abstract: true,
        url: '/connections',
      })
      .state('mock.cwa.accounts.connections.stripe', {
        abstract: true,
        url: '/stripe',
      })
      .state('mock.cwa.accounts.connections.stripe.complete', {
        abstract: true,
        url: '/complete?code',
        params: {
          code: '',
        },
      })
      .state('mock.cwa.accounts.connections.square', {
        abstract: true,
        url: '/square',
      })
      .state('mock.cwa.accounts.connections.square.complete', {
        abstract: true,
        url: '/complete?code',
        params: {
          code: '',
        },
      })
      .state('mock.cwa.accounts.connections.feed', {
        abstract: true,
        url: '/feed',
      })
      .state('mock.cwa.accounts.connections.connection', {
        abstract: true,
        url: '',
      })
      .state('mock.cwa.accounts.connections.statements', {
        abstract: true,
        url: '/statements',
      })
      .state('mock.cwa.accounts.connections.statements.new', {
        abstract: true,
        url: '/new',
      })
      .state('mock.cwa.documents', {
        abstract: true,
        url: '/documents?{from:date}&{to:date}&year&month&resultsPerPage',
        params: {
          resultsPerPage: {
            value: '40',
            squash: false,
          },
          year: {
            value: '',
            squash: true,
          },
          month: {
            value: '',
            squash: true,
          },
          from: new Date(currentYear, 0, 1),
          to: new Date(currentYear, 11, 31),
        },
      })
      .state('mock.cwa.documents.other', {
        abstract: true,
        url: '/{documentFilter:receipt|statement|tax|other}?page',
        params: {
          documentFilter: '',
          page: {
            value: '1',
            squash: true,
          },
        },
      })
      .state('mock.cwa.documents.unmatchedReceipts', {
        abstract: true,
        url: '/unmatched-receipts?page',
        params: {
          page: {
            value: '1',
            squash: true,
          },
        },
      })
      .state('mock.cwa.documents.unmatchedReceipts.receipt', {
        abstract: true,
        url: '/receipt/{receiptId:[0-9a-zA-Z]*}',
      })
      .state('mock.cwa.newsFeed', {
        abstract: true,
        url: '',
      })
      .state('mock.cwa.documents.uploads', {
        abstract: true,
        url: '/uploads?page',
        params: {
          page: {
            value: '1',
            squash: true,
          },
        },
      })
      .state('mock.cwa.newsFeed.events', {
        abstract: true,
        url: '',
      })
      .state('mock.cwa.newsFeed.events.categorize', {
        abstract: true,
        url: '/categorize',
      })
      .state('mock.cwa.newsFeed.feed', {
        abstract: true,
        url: '/messages?anchorScroll',
        params: {
          anchorScroll: '',
        },
      })
      .state('mock.cwa.reports', {
        abstract: true,
        url: '/reports?startDate&endDate',
        params: {
          startDate: `${currentYear}-01-01`,
          endDate: `${currentYear}-12-31`,
        },
      })
      .state('mock.cwa.reports.summary', {
        abstract: true,
        url: '/summary',
      })
      .state('mock.cwa.reports.awaiting', {
        abstract: true,
        url: '/awaiting-category/{type:expense|revenue}',
      })
      .state('mock.cwa.reports.balanceSheet', {
        abstract: true,
        url: '/balance-sheet',
      })
      .state('mock.cwa.reports.incomeStatement', {
        abstract: true,
        url: '/income-statement',
      })
      .state('mock.cwa.reports.ledger', {
        abstract: true,
        url: '/{reportType:income-statement|balance-sheet}/{ledgerAccountId:[0-9]*}?pattern',
      })
      .state('mock.cwa.reports.ledger.transaction', {
        abstract: true,
        url: '/transaction/{transactionId:[0-9a-zA-Z]*}',
      })
      .state('mock.cwa.reports.ledger.tagging', {
        abstract: true,
        url: '/tagging',
      })
      .state('mock.cwa.reports.search', {
        abstract: true,
        url: `/search?${searchParams.join('&')}`,
        params: {
          page: {
            value: '1',
            squash: true,
          },
          'results-per-page': {
            value: '20',
            squash: true,
          },
        },
      })
      .state('mock.cwa.reports.search.transaction', {
        abstract: true,
        url: '/transaction/{transactionId:[0-9a-zA-Z]*}',
      })
      .state('mock.cwa.settings', {
        abstract: true,
        url: '/settings',
      })
      .state('mock.cwa.settings.billing', {
        abstract: true,
        url: '/billing',
      })
      .state('mock.cwa.settings.billing.invoices', {
        abstract: true,
        url: '/invoices',
      })
      .state('mock.cwa.settings.profile', {
        abstract: true,
        url: '/profile',
      })
      .state('mock.cwa.settings.referAFriend', {
        abstract: true,
        url: '/refer-a-friend',
      })
      .state('mock.cwa.error', {
        abstract: true,
        url: '/error/{code:[0-9]*}',
      });
  });
